import React from "react";
import "./recommendations.css";
import whiteWaves from "../../media/images/whiteWaves.png";
import recommend1 from "../../media/images/recommend1.jpeg";
import recommend2 from "../../media/images/recommend2.png";
import recommend3 from "../../media/images/recommend3.png";
import recommend4 from "../../media/images/recommend4.png";
import recommend5 from "../../media/images/recommend5.png";
import recommend6 from "../../media/images/recommend6.png";

const Recommendations = () => {
    return (
        <section id="recommendations">
            <h1 className="head" data-aos="fade-up">
                מה לקוחות אומרים
            </h1>
            <div
                id="carouselExampleLight"
                className="carousel carousel-light slide"
            >
                <div className="carousel-indicators">
                    <button
                        type="button"
                        data-bs-target="#carouselExampleLight"
                        data-bs-slide-to="0"
                        className="active"
                        aria-current="true"
                        aria-label="Slide 1"
                    ></button>
                    <button
                        type="button"
                        data-bs-target="#carouselExampleLight"
                        data-bs-slide-to="1"
                        aria-label="Slide 2"
                    ></button>
                    <button
                        type="button"
                        data-bs-target="#carouselExampleLight"
                        data-bs-slide-to="2"
                        aria-label="Slide 3"
                    ></button>
                    <button
                        type="button"
                        data-bs-target="#carouselExampleLight"
                        data-bs-slide-to="3"
                        aria-label="Slide 4"
                    ></button>
                    <button
                        type="button"
                        data-bs-target="#carouselExampleLight"
                        data-bs-slide-to="4"
                        aria-label="Slide 5"
                    ></button>
                    <button
                        type="button"
                        data-bs-target="#carouselExampleLight"
                        data-bs-slide-to="5"
                        aria-label="Slide 6"
                    ></button>
                </div>
                <div className="carousel-inner">
                    <div
                        className="carousel-item active"
                        data-bs-interval="1000"
                    >
                        <div className="carousel-caption">
                            <img
                                className="recommend-img"
                                src={recommend1}
                                alt="Recommendation"
                            />
                        </div>
                    </div>
                    <div className="carousel-item" data-bs-interval="2000">
                        <div className="carousel-caption">
                            <img
                                className="recommend-img"
                                src={recommend2}
                                alt="Recommendation"
                            />
                        </div>
                    </div>
                    <div className="carousel-item" data-bs-interval="3000">
                        <div className="carousel-caption">
                            <img
                                className="recommend-img"
                                src={recommend3}
                                alt="Recommendation"
                            />
                        </div>
                    </div>
                    <div className="carousel-item" data-bs-interval="4000">
                        <div className="carousel-caption">
                            <img
                                className="recommend-img"
                                src={recommend4}
                                alt="Recommendation"
                            />
                        </div>
                    </div>
                    <div className="carousel-item" data-bs-interval="5000">
                        <div className="carousel-caption">
                            <img
                                className="recommend-img"
                                src={recommend5}
                                alt="Recommendation"
                            />
                        </div>
                    </div>
                    <div className="carousel-item" data-bs-interval="6000">
                        <div className="carousel-caption">
                            <img
                                className="recommend-img"
                                src={recommend6}
                                alt="Recommendation"
                            />
                        </div>
                    </div>
                </div>
                <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleLight"
                    data-bs-slide="prev"
                >
                    <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleLight"
                    data-bs-slide="next"
                >
                    <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
            <a
                href="https://www.instagram.com/stories/highlights/18420312367047062/"
                target="_blank"
                rel="noopener noreferrer"
            >
                למקור
            </a>

            <img src={whiteWaves} alt="White waves" />
        </section>
    );
};

export default Recommendations;
